import {getLanguageFromLS} from '@innowise-group/utilities';

export function getLocale() {
  switch (getLanguageFromLS()) {
    case 'en':
      return 'en-US';
    case 'ru':
    default:
      return 'ru-RU';
  }
}
